import { TIntegrationsTableRow } from './hooks/useIntegrationsTable'

export const getIntegrationsTableRowId = (row: TIntegrationsTableRow) =>
    row?.asset?.id ?? row?.integration?.id
